import script from "./GenomicsTestResults.vue?vue&type=script&setup=true&lang=js"
export * from "./GenomicsTestResults.vue?vue&type=script&setup=true&lang=js"

import "./GenomicsTestResults.vue?vue&type=style&index=0&id=5befbe4d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5befbe4d"]])

export default __exports__